import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgChatBubble = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 64 72"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="hsl(var(--system-icon-background-default))"
        d="M0 10.667C0 4.776 4.776 0 10.667 0h42.666C59.224 0 64 4.776 64 10.667v42.666C64 59.224 59.224 64 53.333 64H10.667C4.776 64 0 59.224 0 53.333z"
      />
      <path
        fill="hsl(var(--system-icon-background-default))"
        d="M8 62.34c0-.556.677-1.007 1.511-1.007h12.975c1.346 0 2.02 1.086 1.068 1.72l-12.974 8.65c-.952.635-2.58.185-2.58-.713z"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M50.314 32.022c-5.971 1.882-12.115 3.036-18.309 3.036s-12.362-1.153-18.308-3.036c-.397-.125-.719.301-.422.627 3.592 3.638 8.473 5.895 13.478 6.849 1.734.326 3.492.502 5.252.502s3.518-.176 5.252-.502c5.005-.98 9.86-3.21 13.478-6.849.273-.326-.025-.752-.421-.627"
      />
    </svg>
  );
};
export default SvgChatBubble;
